var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 360,
    viewBox: "0 0 1440 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37257 0 0 5.37258 0 12V347.188C0 354.124 5.86334 359.616 12.7847 359.162L1428.78 266.369C1435.09 265.956 1440 260.718 1440 254.395V12C1440 5.37257 1434.63 0 1428 0H12Z",
    fill: "url(#paint0_linear_1_67)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_67",
    x1: -5.10798e-8,
    y1: 179.998,
    x2: 1440,
    y2: 179.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00123F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#081B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1D3360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#405A88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F6B99"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.b2f64d8096361a20248ec777e3a25b3a.svg";
export { ForwardRef as ReactComponent };